<template>
  <div class="today-call">
    <FilterHeader
      @search="search"
      @refresh="refresh"
    >
      <div class="call-pop-screen-filter-options">
        <div
          :class="['filter-option', { active: filterIndex === 0 }]"
          @click="changeFilter(0)"
        >{{ $t('callPopScreen.byCallTimeDesc') }}</div>
        <div
          :class="['filter-option', { active: filterIndex === 1 }]"
          @click="changeFilter(1)"
        >{{ $t('callPopScreen.byCallCountDesc') }}</div>
        <div
          :class="['filter-option', { active: filterIndex === 2 }]"
          @click="changeFilter(2)"
        >{{ $t('callPopScreen.byCallTimeAsc') }}</div>
      </div>
    </FilterHeader>
    <div class="group-tabs">
      <div
        :class="['group-tabs-item', { active: groupIndex === 0 }]"
        @click="changeGroup(0)"
        :title="$t('callPopScreen.unprocessed')"
      >{{ $t('callPopScreen.unprocessed') }}</div>
      <div
        :class="['group-tabs-item', { active: groupIndex === 1 }]"
        @click="changeGroup(1)"
        :title="$t('callPopScreen.taskGenerated')"
      >{{ $t('callPopScreen.taskGenerated') }}</div>
      <div
        :class="['group-tabs-item', { active: groupIndex === 2 }]"
        @click="changeGroup(2)"
        :title="$t('callPopScreen.processed')"
      >{{ $t('callPopScreen.processed') }}</div>
      <div
        :class="['group-tabs-item', { active: groupIndex === 3 }]"
        @click="changeGroup(3)"
        :title="$t('callPopScreen.cancelled')"
      >{{ $t('callPopScreen.cancelled') }}</div>
    </div>
    <div class="call-list">
      <template v-if="isFinished && callList.length === 0">
        <div class="view-more">
          <div class="view-more-btn">{{ $t('callPopScreen.noRecords') }}</div>
        </div>
      </template>
      <template v-else>
        <CallInfoItem
          v-for="(item) in callList"
          :key="item.id"
          :item="item"
          :fieldMap="{
            clePhone: 'caller',
            areaName: 'caller_areaname'
          }"
          listType="missCall"
          @changegroup="changeGroup"
        />
        <div class="view-more">
          <div v-if="!isFinished" class="view-more-btn" @click="loadMore">{{isLoading ? $t('common.loading') : $t('callPopScreen.viewMore')}}</div>
          <div v-else class="view-more-btn">{{ $t('callPopScreen.noMore') }}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getCdrLostList } from "@/api/ektv3";
import { mapGetters } from 'vuex';
import CallInfoItem from '../callInfoItem/index'
import FilterHeader from '../filterHeader'
import dayjs from 'dayjs';
import { getShortId } from '@/utils'
export default {
  props: {

  },
  data() {
    return {
      callList: [],
      isFinished: false,
      isLoading: false,
      reqParam: {},
      filterIndex: 0,
      groupIndex: 0,
      reqId: ''
    }
  },
  components: {
    CallInfoItem,
    FilterHeader
  },
  inject: ['curCall', 'setCurCall'],
  computed: {
    ...mapGetters(["userInfo"]),
    newCurCall() {
      return this.curCall()
    },
  },
  watch: {
    callList(arr) {
      const index = arr.findIndex(v => v.id === this.newCurCall.id)
      if(index !== -1) {
        const item = arr[index]
        this.setCurCall({
          itemType: this.newCurCall.itemType,
          id: item.id,
          cle_id: item.cle_id,
          cle_name: item.cle_name,
          cle_phone: item.caller,
          call_id: item.call_id,
          call_type: item.call_type
        })
      }
    }
  },
  created() {
    this.reqParam = {
      ag_id: [this.userInfo.userId],
      page: 0,
      rows: 20,
      size: 20,
      sort: 'start_time',
      order: 'desc',
      deal_status: [0]
    }
    this.reqId = getShortId()
    this.getCdrList(false, this.reqId)
    // 监听更新客户
    // this._Bus.$on("updClient", this.updClient);
  },
  beforeDestroy() {
    // this._Bus.$off("updClient", this.updClient)
  },
  methods: {
    getCdrList(isRefresh, reqId) {
      if(isRefresh) {
        this.isFinished = false
        this.reqParam.page = 0
        this.reqParam.rows = 20
        this.reqParam.size = 20
        this.callList = []
      }
      if(this.isFinished) return
      this.isLoading = true
      const { my: { ektv3_page }, } = this._config.URL;
      getCdrLostList(ektv3_page, { ...this.reqParam, page: this.reqParam.page + 1 }).then(res => {
        if(res.code === 0 && this.reqId === reqId) {
          this.reqParam.page++
          this.callList = [...this.callList, ...res.data.data]
          if(res.data.data.length < 20) {
            this.isFinished = true
          }
        }
      }).finally(() => {
        if(this.reqId === reqId) {
          this.isLoading = false
        }
      })
    },
    search(val) {
      if(/^\d+$/.test(val)) {
        this.reqParam.caller = val
        this.reqParam.cle_name = undefined
      } else {
        this.reqParam.cle_name = val
        this.reqParam.caller = undefined
      }
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    refresh() {
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    changeFilter(val) {
      this.filterIndex = val
      if(val === 0) {
        this.reqParam.sort = 'start_time'
        this.reqParam.order = 'desc'
      } else if(val === 1) {
        this.reqParam.sort = 'inbound_times'
        this.reqParam.order = 'desc'
      } else {
        this.reqParam.sort = 'start_time'
        this.reqParam.order = 'asc'
      }
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    changeGroup(val) {
      this.groupIndex = val
      if(val === 0) {
        this.reqParam.deal_status = [0]
      } else if(val === 1) {
        this.reqParam.deal_status = [3]
      } else if(val === 2) {
        this.reqParam.deal_status = [1]
      } else {
        this.reqParam.deal_status = [2]
      }
      this.reqId = getShortId()
      this.getCdrList(true, this.reqId)
    },
    loadMore() {
      this.reqId = getShortId()
      this.getCdrList(false, this.reqId)
    },
    onSwitchClient(item) {
      const index = this.callList.findIndex((v) => v.id === item.id)
      if(index !== -1) {
        const newItem = { ...this.callList[index], ...item }
        this.callList.splice(index, 1, newItem)
      }
    },
    updClient(clientInfo) {
      const item = {
        id: clientInfo.id,
        cle_id: clientInfo.cle_id,
        cle_name: clientInfo.cle_name,
        caller: clientInfo.cle_phone
      }
      this.onSwitchClient(item)
    },
  }
}
</script>

<style lang="less" scoped>
.today-call {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  .group-tabs {
    display: flex;
    align-items: center;
    height: 24px;
    margin-bottom: 8px;
    padding: 0 12px;
    gap: 8px;
    &-item {
      flex: 1;
      display: inline-block;
      line-height: 24px;
      text-align: center;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      height: 100%;
      padding: 0 8px;
      background: #F2F3F5;
      border-radius: 6px;
      color: #323233;
      font-size: 12px;
      user-select: none;
      cursor: pointer;
      &.active {
        color: #0090ff;
        font-size: 12px;
        font-weight: 600;
        background: #E6F8FF;
      }
    }
  }
  .call-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    .view-more {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 40px;
      color: #969799;
      font-size: 14px;
      &-btn {
        display: flex;
        align-items: center;
        height: 100%;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Home/callPopScreenTab/missCall/index.vue